import React, { Fragment, useEffect } from 'react';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import history from '../../../../../history';
import PrintIcon from '@material-ui/icons/Print';
import FindInPageIcon from '@material-ui/icons/FindInPage';

const ReactTableActions = ({data, state }) => {   
    
    useEffect(()=>{
      console.log(data);
    },[]);

    
    return (<Fragment>
              <td role="cell">
                    <Tooltip title="Consultar">
                      <IconButton aria-label="consult-debit-data" style={{ padding: 2 }} 
                        onClick={() => {
                            history.push({
                              pathname: process.env.PUBLIC_URL + '/billing/add-debit-notes',
                              state: { numNota: 1 }
                            });
                          }}
                      >
                        <FindInPageIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Imprimir">
                      <IconButton
                        aria-label="print" 
                        style={{ padding: 2 }}
                        onClick={()=> {
                          history.push({
                            pathname: process.env.PUBLIC_URL +'/view/invoice-generator',
                            state: { dataInvoice: data.original }
                          });
                        }}
                      >
                        <PrintIcon />
                      </IconButton>
                    </Tooltip>
              </td>
            </Fragment>)
  }

export default reduxForm({
  form: `modal-form`, // a unique identifier for this form
})(withTranslation('common')(ReactTableActions));